import axios from "axios";

export const getWorksheets = async (token, queryStr) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CGF_API}/worksheet/v1/listing?${queryStr}`,
    {
      headers:{
        'Authorization':`Bearer ${token}`
      }
    }
  );
  return response?.data;
};
